var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex notfind"},[_c('div',{staticClass:"notfind-box"},[_c('img',{attrs:{"src":require("@/assets/images/public/404.png"),"alt":""}}),_c('h3',[_vm._v("Sorry,页面不存在！")]),_c('p',[_vm._v("您可以去 "),_c('em',{on:{"click":_vm.goIndex}},[_vm._v("首页")]),_vm._v(" 看看~")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }